import React from 'react'
import { cn } from '../../utils/cn'

const CommonCardView = ({ children, className }) => {
    return (
        <div className={cn('grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4', className)}>{children}</div>
    )
}

export default CommonCardView